import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CardModule } from 'primeng/card'
import { ButtonModule } from 'primeng/button';
import { Carrier } from '../../../models/carrier';
import { ClaimService } from '../../../services/claim.service';

@Component({
  selector: 'app-carrier-search',
  standalone: true,
  imports: [AutoCompleteModule, FormsModule, DatePipe, CardModule, ButtonModule],
  templateUrl: './carrier-search.component.html',
  styleUrl: './carrier-search.component.scss'
})
export class CarrierSearchComponent 
{
  @Input() placeholder: string = "Search";
  @Output() carrierSelected = new EventEmitter<Carrier>();
  @ViewChild('carrierSearchComponent') carrierSearchField?: AutoComplete;


  constructor
  (
    public _claimService: ClaimService
  )
  {
    
  }

  

  carrierSuggestions: Carrier[] = [];
  selectedCarrier? : Carrier;


  carrierSearch(event:AutoCompleteCompleteEvent )
  {
    //Update the suggestions to our query results
    this._claimService.searchCarriers(event.query)
    .then
    (
      carriers => 
        {
          this.carrierSuggestions = carriers;
        }
    )
  }

  selectCarrier(event: AutoCompleteSelectEvent)
  {
    this.carrierSelected.emit(this.selectedCarrier);
  }

  searchFor(input: string)
  {
    if(this.carrierSearchField)
    {
      this.carrierSearchField.writeValue(input);
      this.carrierSearchField.search(null,input,null);
    }
  }

}


